const { notificationPhrases } = require('./operation-phrases');
const moment = require('moment');

// TODO: should we separate changes by multiple users?
function mergeCloseOperations({operations, secondsApart = 3, lastOperationReceived}) {
  if (operations.length == 0) return;
  const timezoneOffset = getTimezone();
  let lastOperation;
  let prevRow;
  let prevDateSeen;
  let prevUserSeen;
  const deepCopy = (row) => {
    const copy = Object.assign({},row);
    if (copy.messages) {
      copy.messages = Object.assign([],copy.messages);
    }
    return copy;
  }

  const cleanOperations = [];
  for (const row of operations) {
    const currDate = moment(row.createdTime).utcOffset(timezoneOffset).format('x');
    const currUser = row.userId;
    if (!prevUserSeen) {
      prevUserSeen = currUser;
    }

    if (!lastOperation) {

      // clone and sever references
      lastOperation = deepCopy(row);
      mergeIntoOperation(lastOperation,null)
    } else if ((prevDateSeen - currDate <= 1000 * secondsApart) && prevUserSeen === currUser) {
      if (isOperationBoundary({prevRow,row,lastOperationReceived})) {
        cleanOperations.push(lastOperation);
        lastOperation = deepCopy(row);
        mergeIntoOperation(lastOperation,null);
      } else {
        mergeIntoOperation(lastOperation,row);
      }
    } else {
      cleanOperations.push(lastOperation);
      lastOperation = deepCopy(row);
      mergeIntoOperation(lastOperation,null)
    }
    prevDateSeen = currDate;
    prevUserSeen = currUser;
    prevRow = row;
  }
  if (lastOperation) {
    cleanOperations.push(lastOperation)
  }
  return cleanOperations;
}

// separate clusters of operations based on operation type
function isOperationBoundary({prevRow,row,lastOperationReceived}) {
  if (!prevRow) return false;
  if (lastOperationReceived && row._id && row._id === lastOperationReceived) {
    // separate note for things seen vs not seen
    return true;
  }

  // if user added several comments in a row, don't group this notification with other changes around the same time
  if (row.operation === 'addComment' && prevRow.operation !== 'addComment') return true;
  if (prevRow.operation === 'addComment' && row.operation !== 'addComment') return true;

  if (row.operation === 'resolveComment' && prevRow.operation !== 'resolveComment') return true;
  if (prevRow.operation === 'resolveComment' && row.operation !== 'resolveComment') return true;

  if (row.operation === 'unresolveComment' && prevRow.operation !== 'unresolveComment') return true;
  if (prevRow.operation === 'unresolveComment' && row.operation !== 'unresolveComment') return true;

  return false;
}

function mergeIntoOperation(groupOperation,newOperation) {
  if (groupOperation.operation != 'operationSequence') {
    const clonedOp = Object.assign({},groupOperation);
    groupOperation.operation = 'operationSequence';
    groupOperation.messages = [clonedOp];
  }
  if (!groupOperation.messages) {
    groupOperation.messages = [];
  }
  if (newOperation) {
    groupOperation.messages.push(newOperation);
  }
}


/*
  get all elements changed by this operation
*/
function getOperationElements(message) {
  if (message.operation == 'batchOperation' || message.operation == 'operationSequence') {
    let nodeIds = [];
    let linkIds = [];
    let regionIds = [];
    let commentIds = [];
    for (const _message of message.messages) {
      const elements = getOperationElements(_message);
      nodeIds = nodeIds.concat(elements.nodeIds);
      linkIds = linkIds.concat(elements.linkIds);
      regionIds = regionIds.concat(elements.regionIds);
      commentIds = commentIds.concat(elements.commentIds);
    }
    const filteredNodeIds = Array.from(new Set(nodeIds));
    const filteredLinkIds = Array.from(new Set(linkIds));
    const filteredRegionIds = Array.from(new Set(regionIds));
    const filteredCommentIds = Array.from(new Set(commentIds));
    return {nodeIds: filteredNodeIds,linkIds: filteredLinkIds, regionIds: filteredRegionIds, commentIds: filteredCommentIds}
  }

  return _getOperationElements(message)
}

// given any operation message, get us a list of impacted node and link ids
function _getOperationElements(message) {
  let nodeIds = [];
  let linkIds = [];
  let regionIds = [];
  let commentIds = [];

  if (message.node && message.node.id) {
    nodeIds.push(message.node.id || message.node.uuid);
  }

  if (message.nodeId) {
    nodeIds.push(message.nodeId);
  }

  if (message.nodeUUID) {
    nodeIds.push(message.nodeUUID);
  }

  if (message.mapNodeUUID) {
    nodeIds.push(message.mapNodeUUID);
  }

  if (message.nodeIds && message.nodeIds.length) {
    nodeIds = nodeIds.concat(message.nodeIds);
  }

  if (message.nodePositions && message.nodePositions.length) {
    nodeIds = nodeIds.concat(message.nodePositions.map(n => n.uuid));
  }

  if (message.nodes && message.nodes.length) {
    nodeIds = nodeIds.concat(message.nodes.map(n => n.uuid));
  }

  if (message.selectedNodes && message.selectedNodes.length) {
    nodeIds = nodeIds.concat(message.selectedNodes);
  }

  if (message.link && message.link.id) {
    linkIds.push(message.link.id);
  }

  if (message.prevLink && message.prevLink.id) {
    linkIds.push(message.prevLink.id);
  }

  if (message.linkId) {
    linkIds.push(message.linkId);
  }

  if (message.linkUUID) {
    linkIds.push(message.linkUUID);
  }

  if (message.linkIds && message.linkIds.length) {
    linkIds = linkIds.concat(message.linkIds)
  }

  if (message.linkAngles && message.linkAngles.length) {
    linkIds = linkIds.concat(message.linkAngles.map(l => l.uuid))
  }

  if (message.links && message.links.length) {
    linkIds = linkIds.concat(message.links.map(l => l.uuid));
  }

  if (message.regionUUID) {
    regionIds.push(message.regionUUID);
  }

  if (message.comment) {
    commentIds.push(message.comment.id);
  }

  if (message.operation === 'editComment' && message.uuid) {
    commentIds.push(message.uuid);
  }

  if (message.operation === 'deleteComment' && message.uuid) {
    commentIds.push(message.uuid);
  }

  if (message.operation === 'undeleteComment' && message.uuid) {
    commentIds.push(message.uuid);
  }

  if (message.operation === 'resolveComment' && message.uuid) {
    commentIds.push(message.uuid);
  }

  if (message.operation === 'unresolveComment' && message.uuid) {
    commentIds.push(message.uuid);
  }

  if (message.operation === 'updateCommentDisplayProperties' && message.uuid) {
    commentIds.push(message.uuid);
  }

  return {nodeIds,linkIds,regionIds,commentIds};
}

function classifyOperation(message) {
  let type = message.operation;

  if (message.operation === 'updateNodePositions') {
   // console.log('d',classifyUpdateNodePositions(data),data)
    const classification = classifyUpdateNodePositions(message);
    if (classification) {
      type = `updateNodePositions.${classification}`;
    } else {
      type = 'updateNodePositions';
    }
  }

  if (message.operation === 'addBatch') {
    type = 'function.paste';
  }

  if (message.operation === 'addNode' &&
      message.node && message.node.parentId) {
    type = 'function.addPart';
  }

  if (message.operation === 'batchOperation') {
    type = identifyBatchOperation(message.messages);
  }

  if (message.operation === 'updateMapDisplayProperties') {
    if (message.displayProperties && message.displayProperties.annotationStyle) {
      type = 'updateMapDisplayProperties.annotationStyle';
    }
  }

  if (message.operation == 'updatePerspectiveNodeViews') {
    if (message.nodeViews && message.nodeViews[0]) {
      const nodeView = message.nodeViews[0];
      if (nodeView.title) {
        type = 'updatePerspectiveNodeViews.annotationTitle';
      } else if (nodeView.displayProperties && nodeView.displayProperties.annotationPosition) {
        type = 'updatePerspectiveNodeViews.annotationPosition';
      }
    }
  }
  return `operation.${type}`
}

function hasOperation(operations,matches) {
  for (const match of matches) {
    if (operations.find(o => o === match)) {
      return match
    }
  }
  return null;
}

function identifyBatchOperation(messages) {
  const operations = messages.map(m => m.operation);
  // identify the relevant actions in a batch operation

  // bulk operation - same operation on multiple elements
  if (operations.length > 1 && operations.every(o => o === operations[0])) {
    return `bulk.${operations[0]}`;
  }

  if (operations.length > 1 && operations.every(o => o === 'setNodeBackgroundColor' || o === 'setNodeDisplayStyle')) {
    return `bulk.setNodeBackgroundColor.setNodeDisplayStyle`;
  }

  // addPart = addNode with a parent id
  if (operations[0] === 'addNode' && messages[0].node && messages[0].node.parentId) {
    return 'function.addPart';
  }

  // addBatch is only called by the paste function
  if (operations.find(o => o === 'addBatch')) {
    return 'function.paste';
  }

  // addNode + updatePositions = group nodes into a new card
  if (operations.length > 1 &&
      operations[0] === 'addNode' &&
      operations[1] === 'updateNodePositions' &&
      messages[1].selectedNodes && messages[1].selectedNodes.length > 1) {
    return 'function.createSystemFromSelection';
  }

  const deleteNodesIndex = operations.findIndex(o => o ==='deleteNodes')
  if (deleteNodesIndex >= 0) {
    if (messages[deleteNodesIndex].nodeIds && messages[deleteNodesIndex].nodeIds.length > 1) {
      return 'deleteNodes.bulk';
    }
    return 'deleteNodes';
  }

  if (hasOperation(operations,['addPerspectivePoint']) && hasOperation(operations,['addToPerspectiveView'])) {
    return 'addPerspectivePoint.addToPerspectiveView';
  }

  // if any of the following are present in the operation list, then they're the op that matters
  const match = hasOperation(operations,[
    'undeleteNodes',
    'undeleteLink',
    'deleteLink',
    'createNewTag',
    'removeTagFromMap',
    'addNode',
    'addLink',
    'editNode',
    'addPerspectivePoint',
    'deletePerspectivePoint',
    'undeletePerspectivePoint',
  ]);

  if (match) {
    return match;
  }

  const upIndex = operations.findIndex(o => o === 'updateNodePositions');
  if (upIndex >= 0) {
    // console.log('m', classifyUpdateNodePositions(messages[upIndex]), messages[upIndex],)
    const classification = classifyUpdateNodePositions(messages[upIndex]);
    if (classification) {
      return `updateNodePositions.${classification}`;
    }
    return 'updateNodePositions';
  }

  // if all else fails, join all our batch ops and return them
  return operations.join('.');
}

function classifyUpdateNodePositions(message) {
  const {
    nodes, prevNodes, links, prevLinks, selectedNodes,
  } = unpackUpdateNodePositionsMessage(message);

  let positionChanges = 0;
  let type;
  const typeCount = {
    emancipationadoption: 0,
    adoption: 0,
    emancipation: 0,
    reorder: 0,
    moveNode: 0,
  };
  for (const uuid in nodes) {
    const node = nodes[uuid];
    const prevNode = prevNodes[uuid];
    // if a node gained a new parent
    if (!node || !prevNode) {
      continue;
    }

    if (node.parentId && prevNode.parentId && node.parentId !== prevNode.parentId) {
      type = type || 'emancipationadoption'
      typeCount.emancipationadoption++
    } else if (node.parentId && !prevNode.parentId) {
      type = type || 'adoption';
      typeCount.adoption++;
    } else if (!node.parentId && prevNode.parentId) {
      type = type || 'emancipation';
      typeCount.emancipation++;
    } else if (node.orderIndex !== prevNode.orderIndex) {
      type = type || 'reorder';
      typeCount.reorder++;
    } else if (node.x !== prevNode.x || node.y !== prevNode.y) {
      positionChanges++;
      typeCount.moveNode++;
    }
  }
  if (positionChanges) {
    type = type || 'moveNode';
  }

  if (type) {
    if (typeCount[type] === 1 || (selectedNodes && selectedNodes.length === 1)) {
      return type;
    } else if (typeCount[type] > 1) {
      return `bulk.${type}`;
    }
  }

  // data may be in older format, or nothing changed...
  return '';
}

function unpackUpdateNodePositionsMessage(message) {
  const {
    prevNodePositions,
    prevLinkAngles,
    nodePositions,
    linkAngles,
    selectedNodes
  } = message;

  const nodes = {};
  const prevNodes = {};
  const links = {};
  const prevLinks = {};

  if (nodePositions && nodePositions.length) {
    for (const n of nodePositions) {
      nodes[n.uuid] = n;
    }
  }

  if (prevNodePositions && prevNodePositions.length) {
    for (const n of prevNodePositions) {
      prevNodes[n.uuid] = n;
    }
  }

  if (linkAngles && linkAngles.length) {
    for (const l of linkAngles) {
      links[l.uuid] = l;
    }
  }

  if (prevLinkAngles && prevLinkAngles.length) {
    for (const l of prevLinkAngles) {
      prevLinks[l.uuid] = l;
    }
  }
  return {nodes, prevNodes, links, prevLinks, selectedNodes}
}

/* summarize an operation as an english phrase */
function operation2english({message,elements}) {
  //console.log('operation2english',message,elements)
  if (message.operation == 'operationSequence') {
    return operationSequence2english({message,elements});
  }

  const classification = classifyOperation(message);
  const template = getOperationPhraseTemplate(classification);
  const phrase = _formPhrase({template, elements})
  return {classification, template, phrase};
}

function getOperationPhraseTemplate(classification) {
  const lookupToken = classification.replace(/^operation\./,'');
  const template = notificationPhrases[lookupToken];
  return template || notificationPhrases.DEFAULT;
}

function getOperationGeneralAction(classification) {
  if (classification.match(/addLink|addNode|addRegion|createSystemFromSelection|addBatch|addComment/i)) return 'add';
  if (classification.match(/delete|remove/i)) return 'delete';
  if (classification.match(/undelete/i)) return 'restore';
  if (classification.match(/editNode/i)) return 'edit';
  if (classification.match(/Layout|Color|Width|LinkType|Style|LinkDirection|annotationStyle/i)) return 'style';
  if (classification.match(/Layout|setChildrenDetached/i)) return 'layout';
  if (classification.match(/setCollapsedState/i)) return 'collapse-expand';
  if (classification.match(/setLinkAngles|updateNodePositions|setLinkEndpoints|setChildrenPosition/i)) return 'position';
  if (classification.match(/editComment|deleteComment|undeleteComment|updateCommentDisplayProperties/i)) return 'comment-change';
  if (classification.match(/unresolveComment/i)) return 'comment-unresolve';
  if (classification.match(/resolveComment/i)) return 'comment-resolve';

  return 'change';
}
/*
  summarize a series of operations into a readable summary
*/
function operationSequence2english({message,elements}) {
  if (!message.messages) return;

  let generalActions = {};
  for (const _message of message.messages) {
    const classification = classifyOperation(_message);
    const generalAction = getOperationGeneralAction(classification);
    generalActions[generalAction] = 1;
  }
  const actions = Object.keys(generalActions);
  let templateKey;

  if (actions.length === 1) {
    templateKey = `${actions[0]}.operationSequence`;
  } else if (generalActions.add && generalActions.edit && actions.length === 2) {
    templateKey = `add-edit.operationSequence`;
  } else if (generalActions.delete && generalActions.edit && actions.length === 2) {
    templateKey = `delete-edit.operationSequence`;
  } else if (generalActions.delete && generalActions.add && actions.length === 2) {
    templateKey = `add-delete.operationSequence`;
  } else {
    templateKey = `mixed.operationSequence`;
  }

  const template = getOperationPhraseTemplate(templateKey)
  const phrase = _formPhrase({template, elements})

  return {
     classification: 'operationSequence',
     phrase,
     elements
  }
}

/* form a phrase that indicates how many elements were impacted */
function _formPhrase({template, elements}) {
  const nodesAffected = elements.nodeIds.length;
  const linksAffected = elements.linkIds.length;
  const regionsAffected = elements.regionIds.length;
  const commentsAffected = elements.commentIds.length;
  let contentPhrase = '';
  if (nodesAffected && linksAffected && regionsAffected) {
    contentPhrase = `several cards, relationships, and regions`;
  } else if (nodesAffected && regionsAffected) {
    contentPhrase = `several cards and regions`;
  } else if (linksAffected && regionsAffected) {
    contentPhrase = `relationships and regions`;
  } else if (nodesAffected && linksAffected) {
    contentPhrase = `cards and relationships`;
  } else if (nodesAffected && !linksAffected && !regionsAffected) {
    contentPhrase = `${nodesAffected} ${nodesAffected == 1 ? 'card' : 'cards'}`;
  } else if (linksAffected && !nodesAffected && !regionsAffected) {
    contentPhrase = `${linksAffected} ${linksAffected == 1 ? 'relationship' : 'relationships'}`;
  } else if (regionsAffected && !nodesAffected && !linksAffected) {
    contentPhrase = `${regionsAffected} ${regionsAffected == 1 ? 'region' : 'regions'}`;
  } else if (commentsAffected) {
    contentPhrase = `${commentsAffected} ${commentsAffected == 1 ? 'comment' : 'comments'}`;
  }

  let _template = template || 'changed __ITEMS__';
  const phrase = _template.replace(/__ITEMS__/,contentPhrase);
  return phrase;
}


function annotateOperations(log) {
  for (const message of log) {
    const elements = getOperationElements(message);

    const summary = operation2english({message,elements});
    message.readableSummary = summary.phrase;
    message.classification = summary.classification;
    message.nodesAffected = elements.nodeIds.length;
    message.linksAffected = elements.linkIds.length;
    message.regionsAffected = elements.regionIds.length;
    message.elements = elements;
  }
}

  // momentjs is picky with how this is formatted...
function getTimezone() {
  let offset = (new Date().getTimezoneOffset() / 60) * 100;
  if (offset > 0) {
    if (`+${offset}`.length == 2) {
      return `-00${offset}`;
    } else if (`${offset}`.length == 3) {
      return `-0${offset}`;
    } else {
      return `-${offset}`;
    }
  }
  offset = offset * -1;
  if (`${offset}`.length == 2) {
    return `+00${offset}`;
  } else if (`+${offset}`.length == 3) {
    return `+0${offset}`;
  } else {
    return `+${offset}`;
  }
}

module.exports = {
  mergeCloseOperations,
  getOperationElements,
  classifyOperation,
  identifyBatchOperation,
  classifyUpdateNodePositions,
  unpackUpdateNodePositionsMessage,
  operation2english,
  annotateOperations,
  getTimezone,
}



// WEBPACK FOOTER //
// ./shared/lib/map-operation-utils.js